<template>
  <div class="container-fluid subpage">
    <div class="text-center">
      <a class="back back--form" href="/"> Strona główna </a>
    </div>
    <div class="text-center">
      <a href="/">
        <img class="thanks__logo" src="../assets/images/logo.svg" alt />
      </a>
    </div>
    <h1 class="thanks__headline">
      Coś poszło nie tak...
    </h1>
  </div>
</template>

<script>
export default {
  name: "Error",
  title: "Błąd",
  meta: {
    requiresAuth: false,
    title: "Błąd",
    metaTags: [
      {
        name: "description",
        content: "Błąd",
      },
      {
        property: "og:description",
        content: "Błąd.",
      },
    ],
  },
  data() {
    return {
      title: "Error",
    };
  },
};
</script>
